export default "__VITE_ASSET__C_1N6bMs__"